<template>
  <div class="layout">
    <m-header
      title="预约直播"
      :right-options="{ showMore: false }"
      :left-options="{ preventGoBack: true }"
      @on-click-back="goBack"
    ></m-header>
    <div class="content add-live" :style="{ height: wrapHeight + 'px' }">
      <cube-form :model="model" @submit="submitHandler">
        <cube-form-group>
          <cube-form-item :field="fields[0]">
            <cube-input
              v-model="model.title"
              placeholder="请输入直播标题"
              :type="text"
              :maxlength="maxlength"
            ></cube-input>
          </cube-form-item>
          <cube-form-item :field="fields[1]"></cube-form-item>
          <cube-form-item :field="fields[2]">
            <div class="item" @click="showTimePicker">
              {{ model.startTime || '选择时间' }}
              <svg-icon icon-class="right"></svg-icon>
            </div>
          </cube-form-item>
          <cube-form-item :field="fields[3]">
            <div class="item" @click="showTimeLengthPicker">
              {{ model.timeText }}
              <svg-icon icon-class="right"></svg-icon>
            </div>
          </cube-form-item>
          <cube-form-item :field="fields[4]">
            <div class="item" @click="showTypePicker">
              {{ model.liveType || '选择类型' }}
              <svg-icon icon-class="right"></svg-icon>
            </div>
          </cube-form-item>
        </cube-form-group>
        <cube-form-group class="btn">
          <cube-button class="btn-submit" :disabled="btnDisable" :primary="true" type="submit"
            >预约</cube-button
          >
        </cube-form-group>
      </cube-form>
    </div>
    <loading v-if="isLoading" />
  </div>
</template>

<script>
import format from 'date-fns/format';
import addMinutes from 'date-fns/add_minutes';
import MHeader from '@/components/MHeader/Index.vue';
import liveApi from '@/api/live';
import backMixin from '@/mixins/back';
import loadingMixin from '@/mixins/loading';
import { mapGetters } from 'vuex';
import { generateDuration } from '@/utils/index';
import { character } from '@/utils/const';
import Loading from '@/components/Loading/Index.vue';

const duration = generateDuration(30, 120, 5);
const liveType = [
  {
    text: '录播主机',
    value: '1'
  },
  {
    text: '精品直播',
    value: '2'
  }
];

export default {
  name: 'live-add',
  components: {
    MHeader,
    Loading
  },
  data() {
    return {
      wrapHeight: 400,
      liveTitle: '预约直播',
      maxlength: 51,
      validity: {},
      valid: undefined,
      btnDisable: false,
      model: {
        title: '',
        userName: '',
        startTime: '',
        timeText: duration[0].text,
        timeValue: duration[0].value,
        liveType: liveType[0].text,
        liveTypeValue: liveType[0].value
      },
      timeLength: duration,
      liveType,
      fields: [
        {
          /*  type: 'input',
          modelKey: 'title',
          label: '直播标题',
          props: {
            placeholder: '请输入直播标题'
          },

          rules: {
            required: true,
            max: 20,
            pattern: character
          },
          messages: {
            pattern: '直播标题不能包含特殊字符'
          } */
          modelKey: 'title',
          label: '直播标题',
          rules: {
            required: true,
            pattern: character,
            max: 50
          },
          messages: {
            pattern: '直播标题不能包含特殊字符'
          }
        },
        {
          type: 'input',
          modelKey: 'userName',
          label: '预约教师',
          props: {
            placeholder: '请输入预约教师'
          },
          rules: {
            required: true,
            pattern: character,
            max: 10
          },
          messages: {
            pattern: '教师名称不能包含特殊字符'
          }
        },
        {
          modelKey: 'startTime',
          label: '选择时间',
          rules: {
            required: true
          }
        },
        {
          modelKey: 'timeText',
          label: '选择时长',
          rules: {
            required: true
          }
        },
        {
          modelKey: 'liveType',
          label: '选择类型',
          rules: {
            required: true
          }
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'schoolName'])
  },
  mixins: [backMixin, loadingMixin],
  mounted() {
    this.wrapHeight = this.$calcWrapHeight();
    this.initData();
  },
  methods: {
    submitHandler(e) {
      e.preventDefault();
      const that = this;
      console.log('that: ', that);
      const startTimes = `${this.model.startTime}:00`;
      const endTimes = format(
        addMinutes(this.$strToDate(startTimes), parseInt(this.model.timeValue, 10)),
        'YYYY-MM-DD HH:mm:00'
      );
      const params = {
        title: this.model.title,
        userPhone: this.userInfo.mobile,
        userName: this.model.userName,
        deviceCode: '',
        liveType: this.model.liveTypeValue,
        schoolName: this.schoolName,
        deviceIp: '',
        startTime: startTimes,
        endTime: endTimes,
        // wx小程序需要参数
        coverPath: '',
        liveDescription: '  ',
        livePassword: ''
      };
      this.changeLoadingStatus(true);
      this.btnDisable = true;
      liveApi.saveLiveRoom(params).then(response => {
        // if (response.code === 0 && response.result.flag === 1) {
        if (response.code === 1 && response.result.flag !== 1 && response.result.flag !== 2) {
          this.$createToast({
            txt: '直播预约成功',
            type: 'correct'
          }).show();
          // 用于添加成功后，返回列表页，重新获取数据
          this.$route.meta.addSucess = true;
          this.goBack();
        } else {
          this.$createToast({
            txt: response.result.message,
            type: 'error'
          }).show();
        }
        this.changeLoadingStatus(false);
        this.btnDisable = false;
      });
    },
    initData() {
      this.model.userName = this.userInfo.realname;
      this.model.startTime = format(addMinutes(new Date(), 10), 'YYYY-MM-DD HH:mm');
    },
    showTimeLengthPicker() {
      if (!this.timeLengthPicker) {
        this.timeLengthPicker = this.$createPicker({
          title: '选择时长',
          data: [this.timeLength],
          onSelect: this.selectTimeHandle,
          onCancel: this.cancelTimeHandle
        });
      }
      this.timeLengthPicker.show();
    },
    selectTimeHandle(selectedVal, selectedIndex, selectedText) {
      this.model.timeText = selectedText.join('');
      this.model.timeValue = selectedVal.join('');
    },
    showTimePicker() {
      this.$createTimePicker({
        showNow: false,
        minuteStep: 5,
        delay: 15,
        day: {
          len: 5,
          filter: ['今天'],
          format: 'YYYY-MMM-dd'
        },
        max: +new Date() + 60 * 24 * 60 * 60 * 1000,
        format: 'YYYY-MM-DD HH:mm',
        onSelect: (selectedTime, selectedText, formatedTime) => {
          this.model.startTime = formatedTime;
        }
      }).show();
    },
    showTypePicker() {
      if (!this.typePicker) {
        this.typePicker = this.$createPicker({
          title: '选择类型',
          data: [this.liveType],
          onSelect: this.selectTypeHandle
        });
      }
      this.typePicker.show();
    },
    selectTypeHandle(selectedVal, selectedIndex, selectedText) {
      this.model.liveType = selectedText.join('');
      this.model.liveTypeValue = selectedVal.join('');
    }
  }
};
</script>

<style lang="less">
.add-live {
  padding-top: 10px;

  .cube-form {
    font-size: 14px;
    line-height: 1.429;

    .item {
      display: flex;
      justify-content: space-between;

      .svg-icon {
        color: #666;
      }
    }

    .cube-validator-content {
      color: #000;
    }
  }

  .btn {
    background-color: #f6f7f8;
  }

  .btn-submit {
    width: 345px;
    margin: 40px auto 0;
  }
}
</style>
